import { forwardRef } from 'react';
import { closeSnackbar, CustomContentProps } from 'notistack';

import {
    Alert,
    AlertColor,
    SxProps,
    Theme,
    Typography,
} from '@thirdspacelearning/library';

declare module 'notistack' {
    interface VariantOverrides {
        sxSnackbar: {
            severity?: AlertColor;
            title?: string;
            color?: string;
            testId?: string;
            sxProps?: SxProps<Theme>;
        };
    }
}

interface SxSnackbarProps extends CustomContentProps {
    severity?: AlertColor;
    title?: string;
    color?: string;
    testId?: string;
    sxProps?: SxProps<Theme>;
}

const SxSnackbar = forwardRef<HTMLDivElement, SxSnackbarProps>((props, ref) => {
    const { id, message, severity = 'success', title, sxProps, testId } = props;

    const handleClose = () => {
        closeSnackbar(id);
    };

    return (
        <Alert
            ref={ref}
            severity={severity}
            title={title}
            data-testid={testId || 'alert'}
            onClose={handleClose}
            sx={{ ...sxProps }}
        >
            {message && (
                <Typography data-testid="alert-message">{message}</Typography>
            )}
        </Alert>
    );
});

export default SxSnackbar;
